import n from "../../../../@babel/runtime/helpers/esm/extends.js";
import { clsx as v } from "../../../../clsx/dist/clsx.js";
import P from "../extractEventHandlers/extractEventHandlers.js";
import p from "../omitEventHandlers/omitEventHandlers.js";
function j(f) {
  const {
    getSlotProps: a,
    additionalProps: s,
    externalSlotProps: e,
    externalForwardedProps: l,
    className: i
  } = f;
  if (!a) {
    const m = v(s?.className, i, l?.className, e?.className), u = n({}, s?.style, l?.style, e?.style), r = n({}, s, l, e);
    return m.length > 0 && (r.className = m), Object.keys(u).length > 0 && (r.style = u), {
      props: r,
      internalRef: void 0
    };
  }
  const y = P(n({}, l, e)), N = p(e), g = p(l), t = a(y), d = v(t?.className, s?.className, i, l?.className, e?.className), c = n({}, t?.style, s?.style, l?.style, e?.style), o = n({}, t, s, g, N);
  return d.length > 0 && (o.className = d), Object.keys(c).length > 0 && (o.style = c), {
    props: o,
    internalRef: t.ref
  };
}
export {
  j as default
};
